import { render, staticRenderFns } from "./save-alert.vue?vue&type=template&id=36199424"
import script from "./save-alert.vue?vue&type=script&lang=js"
export * from "./save-alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports